export const logSchemas = {
    picklist: {
    columns: [
      { key: "logId", label: "Logid" },
      { key: "plHeadId", label: "Picklist id" },
      { key: "log", label: "Log" },
      { key: "logDate", label: "Date" },
    ],
  },
  po: {
    columns: [
      { key: "logId", label: "Logid" },
      { key: "poId", label: "PO id" },
      { key: "log", label: "Log" },
      { key: "logDate", label: "Date" },
    ],
  },
  edn: {
    columns: [
      { key: "logId", label: "Logid" },
      { key: "ednHeadId", label: "EDN id" },
      { key: "logs", label: "Log" },
      { key: "logDate", label: "Date" },
    ],
  },
  cctv: {
    columns: [
      { key: "logId", label: "Logid" },
      { key: "requestId", label: "Request id" },
      { key: "log", label: "Log" },
      { key: "user", label: "User" },
      { key: "logDate", label: "Date" },
      { key: "alertRead", label: "Alert read" },
    ],
  },
  products: {
    columns: [
      { key: "logId", label: "Logid" },
      { key: "productId", label: "Product id" },
      { key: "variable", label: "Variable" },
      { key: "user", label: "User" },
      { key: "newValue", label: "New value" },
      { key: "productIdOld", label: "Old product id" },
      { key: "changeDate", label: "Date" },
    ],
  },
  vending: {
    columns: [
      { key: "id", label: "Logid" },
      { key: "terminal_id", label: "Terminal id" },
      { key: "slot", label: "Slot" },
      { key: "action", label: "Action" },
      { key: "action_by", label: "Staff" },
      { key: "created_at", label: "Date" },
    ],
  },
}